import { aprListMiddleware as getAprListMiddleware } from './apr-list-middleware';

export const aprMiddleware = [getAprListMiddleware];
